import axios from "@/api/axiosInstance";
import { EditCompletedAttemptResponse } from "./types";
import type {
  CoachAttemptDetail,
  SaveCoachResponsesPayload,
} from "../../types/diagnostic";

/**
 * Correct a completed attempt in place.
 *
 * The attempt stays complete; every changed answer, the notes, the trade
 * selection and any resulting outcome or stage change are written to the
 * attempt's audit trail, so a corrected result is never silently different
 * from what was reported.
 */
export const editCompletedAttempt = async (
  attemptId: number,
  payload: SaveCoachResponsesPayload,
): Promise<CoachAttemptDetail> => {
  const response = await axios.put<EditCompletedAttemptResponse>(
    `/api/private/attempts/${attemptId}/edit`,
    payload,
  );
  return response.data.data;
};
